import React from 'react'
import { useDispatch } from 'react-redux'
import { toggleAttachmentView, addAttachment } from '../var/varSlice'
import { Grid, Button } from '@material-ui/core'
import Upload from '../../components/Upload'


export const AttachmentsForm = ({ varId, varFieldAttachmentId }) => {
    const dispatch = useDispatch()
    const backToList = () => {
        dispatch(
            toggleAttachmentView({ AttachmentId: null, VarFieldAttachmentId: varFieldAttachmentId })
        )
    }
    const validateForm = () => {
        var validation = true
        return validation
    }

    const addObj = (obj) => {
        dispatch(
            addAttachment({
                AttachmentName: obj.file,
                Extension: obj.extension,
                ImageFile: obj.file,
                Url: obj.url,
                VarTransactionId: varId,
                VarFieldAttachmentId: varFieldAttachmentId,
                Id: obj.file
            })
        )
    }

    const saveObj = (obj) => {
        if (!validateForm()) return false
        addObj(obj)
        return true
    }
    return [backToList, validateForm, saveObj];
}

export const AttachmentsUI = (props) => {
    let backToList = props.backToList
    let validateForm = props.validateForm
    let saveObj = props.saveObj
    return (
        <div>
            <Grid container>
                <Grid item xs={3} style={{ marginBottom: "0.75em" }}>
                    <Button color="primary" onClick={backToList} style={{ fontSize: "1.7rem", padding: "auto" }}><i className="fas fa-arrow-left"></i></Button>
                </Grid>
                <Grid item xs={9} style={{ marginBottom: "0.75em" }}>
                    <h4>Unicef VAR</h4>
                </Grid>
            </Grid>
            <Grid container justifyContent="space-evenly">
                <Grid item xs={12}>
                    <Upload url={'/VarTransactions/UploadFile'} accept={props.acceptedFiles} headers={[{ name: "varId", value: props.AttachmentsData.varId }, { name: "varFieldAttachmentId", value: props.AttachmentsData.VarFieldAttachmentId }]} saveObj={saveObj} />
                </Grid>
                <Grid item xs={12} style={{ marginTop: "1rem" }}>
                    <Button variant="contained" onClick={backToList} disabled={!validateForm} type="submit" fullWidth style={{ backgroundColor: "#ffc107", color: "#fff", fontWeight: 700 }}>BACK</Button>
                </Grid>
            </Grid>
        </div>
    )
}

export default AttachmentsForm;